import { useClickOutside } from '@hooks/use-click-outside';
import styles from './modal.module.css';

export default function HeaderVideo({ primarySrc, fallbackSrc, open, onClose }) {
  const reference = useClickOutside(() => {
    onClose();
  });

  return open ? (
    <div
      className={`d-flex ${styles.overlay} snf-lx-components-lavora-con-noi-rework-header-video`}
    >
      <div className="container-fluid position-fixed container-div">
        <div className="row">
          <div className="col snf-color-prussian-blue snf-font-20 font-weight-bold text-center my-3">
            <video className="height-video" autoPlay loop ref={reference} controls playsInline>
              {primarySrc ? <source src={primarySrc} type="video/quicktime" /> : null}
              <source src={fallbackSrc} type="video/mp4" />
              <track kind="captions" />
            </video>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
